import type { SheetTopics } from "../filtersheet/FilterSheetTopics";
import type { OrchestrationTopics } from "../multifiltering/FilterTypes";
import type { PaliTopics } from "./PaliTopics";
import type { SliderTopics } from "../filter/slider/SliderTopics";
import { eventQBus as bus } from "@otto-ec/global-resources/event-q-bus";

export const eventQBus = bus.with<Topics>();

export type Topics = SheetTopics & SliderTopics & OrchestrationTopics & PaliTopics;
